import { useAuth } from '../../context/AuthContext';
import AccessDenied from './AccessDenied';

/**
 * Client mail is for admins and the DPM coordinator department (main or second
 * department) — `user.clientMailAccess`, decided by the server with the session.
 * Not a role: Mohona is a manager, and so are fourteen people who must not see it.
 */
export default function ClientMailRoute({ children }) {
  const { user } = useAuth();
  if (!user?.clientMailAccess) return <AccessDenied what="open Client mail" />;
  return children;
}
